<mapfre-card 
        [singleCard]="false"
        [additionalClasses]="'billing-new-container'">
        <router-outlet></router-outlet>
</mapfre-card>